// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"E0-z"};